if (!customElements.get('needle-alternatives')) {
  customElements.define('needle-alternatives', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.js-product');
      this.onAlternativeClick = (event) => {
        const link = event.target.closest('[data-needle-size]');
        if (!link || !this.section) return;
        const option = Array.from(this.section.querySelectorAll('input[type="radio"].js-option')).find((input) => input.value === link.dataset.needleSize);
        if (option) {
          event.preventDefault();
          option.click();
          option.focus({preventScroll:true});
        }
      };
      this.addEventListener('click', this.onAlternativeClick);
      this.onVariantChange = (event) => {
        const id = event.detail.variant ? String(event.detail.variant.id) : '';
        this.querySelectorAll('[data-needle-variant]').forEach((panel) => {
          panel.hidden = panel.dataset.needleVariant !== id;
        });
        const visiblePanel = this.querySelector('[data-needle-variant]:not([hidden])');
        if (visiblePanel) {
          requestAnimationFrame(() => {
            const rect = visiblePanel.getBoundingClientRect();
            if (rect.top < 90 || rect.bottom > window.innerHeight - 120) {
              visiblePanel.scrollIntoView({
                block: 'center',
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
              });
            }
          });
        }
      };
      if (this.section) this.section.addEventListener('on:variant:change', this.onVariantChange);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onAlternativeClick);
      if (this.section) this.section.removeEventListener('on:variant:change', this.onVariantChange);
    }
  });
}
